const LOGOUT_TRACE_STORAGE_KEY = 'pcPortalLogoutTrace';
const MAX_TRACE_ENTRIES = 250;

const parseTrace = (rawValue) => {
  if (!rawValue) {
    return [];
  }
  try {
    const parsedValue = JSON.parse(rawValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    return [];
  }
};

const readExistingTrace = () => {
  if (typeof window === 'undefined') {
    return [];
  }
  try {
    const localValue = window.localStorage.getItem(LOGOUT_TRACE_STORAGE_KEY);
    const localTrace = parseTrace(localValue);
    if (localTrace.length) {
      return localTrace;
    }
  } catch (error) {
    // Best-effort diagnostics only.
  }
  try {
    const sessionValue = window.sessionStorage.getItem(LOGOUT_TRACE_STORAGE_KEY);
    return parseTrace(sessionValue);
  } catch (error) {
    return [];
  }
};

export const clearLogoutTrace = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(LOGOUT_TRACE_STORAGE_KEY);
    window.sessionStorage.removeItem(LOGOUT_TRACE_STORAGE_KEY);
    window.__pcPortalLogoutTrace = [];
  } catch (error) {
    // Best-effort diagnostics only.
  }
};

export const appendLogoutTrace = (step, details = {}) => {
  if (!step || typeof window === 'undefined') {
    return;
  }
  try {
    const existingTrace = readExistingTrace();
    const traceEntry = {
      at: new Date().toISOString(),
      step,
      href: window.location.href,
      path: window.location.pathname,
      search: window.location.search,
      ...details,
    };
    const nextTrace = [...existingTrace, traceEntry].slice(-MAX_TRACE_ENTRIES);
    const serializedTrace = JSON.stringify(nextTrace);
    window.localStorage.setItem(LOGOUT_TRACE_STORAGE_KEY, serializedTrace);
    window.sessionStorage.setItem(LOGOUT_TRACE_STORAGE_KEY, serializedTrace);
    window.__pcPortalLogoutTrace = nextTrace;
  } catch (error) {
    // Best-effort diagnostics only.
  }
};

export { LOGOUT_TRACE_STORAGE_KEY };
